

export const UniversalActions = {
    navToError: (dispatch: (action: any) => void) => {
        throw "Not Implemented"
    }
}